import { spUrl } from "utils";
import { buildSearchParams, request } from "utils/proxy";
import {
	ADMINISTRATION_AD_HOC_TEAM_URL,
	ADMINISTRATION_ORGANIZATION_URL,
	ADMINISTRATION_PERSON_URL,
	ADMINISTRATION_UNIT_URL,
	ADMINISTRATION_USER_URL,
	API_RESEARCH_ROLES__DEPRECATED, API_UNIT,
} from "globals/constants";


export const picklists = {
	getUnit: (id, options) => request(`${ADMINISTRATION_UNIT_URL}/${id}`, options),
	findUnit: (searchParams, options) => request(`${ADMINISTRATION_UNIT_URL}${buildSearchParams(searchParams)}`, options),

	getOrganization: (id, options) => request(`${ADMINISTRATION_ORGANIZATION_URL}/${id}`, options),
	findOrganization: ({ searchParams }) => request(`${ADMINISTRATION_ORGANIZATION_URL}${buildSearchParams(searchParams)}`),

	getTeam: (id, options) => request(`${ADMINISTRATION_AD_HOC_TEAM_URL}/${id}`, options),
	findTeam: ({ searchParams }) => request(`${ADMINISTRATION_AD_HOC_TEAM_URL}${buildSearchParams(searchParams)}`),

	getPerson: (id, options) => request(`${ADMINISTRATION_AD_HOC_TEAM_URL}/${id}`, options),
	findPeople: (searchParams, options) => request(`${ADMINISTRATION_PERSON_URL}${buildSearchParams(searchParams)}`, options),

	getResearchTeamRoles_deprecated: (options) => request(spUrl(API_RESEARCH_ROLES__DEPRECATED), options),

	// todo: probably need to rename this request. using in TaskModal.js to update user.
	getUser: (params, options) => request(`${ADMINISTRATION_USER_URL}/${params.id}`, options),

	/**
	 * @param {{unitId: string}} params
	 * @param {{}?} options
	 */
	getRateTypes: (params, options) => request(spUrl(`${API_UNIT}/${params.unitId}/idc-rate-types`), options),
};
